"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
const react_1 = __importDefault(require("react"));
const Radio_1 = __importDefault(require("@material-ui/core/Radio"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const utils_1 = require("../../lib/utils");
const theme_1 = __importDefault(require("../../styles/theme"));
const icon_1 = require("../icon");
/**
 *
 * Panel Usage Example:
 *
   <Panel name="panel name">
    <span>text here</span>
    <Button primary>button here</Button>
   </Panel>
 *
 */
const useStyles = makeStyles_1.default({
    upliftPanel: {
        border: `1px solid ${theme_1.default.colors.backgroundInactive}`,
        padding: '14px 14px 14px 26px',
        margin: '5px',
        borderRadius: '4px',
    },
    inputRadio: {
        '&$checked ~ $upliftPanel': {
            borderLeft: '6px solid',
            borderColor: theme_1.default.colors.primaryAccent,
            paddingLeft: '21px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            '& $checkmark': {
                visibility: 'visible',
            },
        },
        '&.Mui-focusVisible ~ $upliftPanel': {
            outline: theme_1.default.outline,
        },
    },
    checked: {},
    checkmark: { visibility: 'hidden', float: 'right' },
});
const Panel = ({ className, id, style, children, name, selected, height = '133.33px', width = '400px', iconSize = '28px', onClick = utils_1.noop, onChange = utils_1.noop, disabled = false, selectable, }) => {
    const classes = useStyles();
    const panel = (react_1.default.createElement("div", { id: id, className: `${classes.upliftPanel} ${className || ''}`, style: Object.assign({ height,
            width, cursor: selectable ? 'pointer' : 'default' }, style), "data-testid": "panel" },
        react_1.default.createElement("span", { className: classes.checkmark },
            react_1.default.createElement(icon_1.Icon, { name: "check_circle", size: iconSize, style: { position: 'absolute', right: '-5px', top: '-5px' } })),
        children));
    return selectable ? (react_1.default.createElement("label", { "data-testid": "panel-label" },
        react_1.default.createElement(Radio_1.default, { style: { opacity: '0', position: 'absolute' }, classes: { root: classes.inputRadio, checked: classes.checked }, value: children, name: name, checked: selected, onClick: onClick, onChange: onChange, disabled: disabled }),
        panel)) : (panel);
};
exports.Panel = Panel;
exports.default = exports.Panel;
